export enum FileMimeType {
  PDF = 'application/pdf',
  EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
  TXT = 'text/plain',
  TIFF = 'image/tiff',
}
